export const hasCordova = typeof cordova !== 'undefined'
// cordova.js のように最初に読み込まれず, deviceready イベント後に有効になるので定数だと正常に判定できない
export const hasDevice = (): boolean => typeof device !== 'undefined'
export const platformIsAndroid = hasCordova && window.cordova.platformId === 'android'
export const platformIsIOS = hasCordova && window.cordova.platformId === 'ios'
